import { API_AUTH, setTokenGlobal } from "../common";
import { Cookies } from "react-cookie";
import { getDomain } from "utils/utils";

var urlNew = getDomain();
const cookies = new Cookies();
var token = cookies.get("userTokenDaiLy");
if (typeof token != "undefined" && token.length > 6) {
  token = token.substring(6);
  setTokenGlobal(token, urlNew);
}

const HuongDanSuDungApi = {
  list: ({ sSearch, iPageIndex, iPageSize }) =>
    API_AUTH.get(
      `HDSD/GetListHDSD_byName?sSearch=${sSearch}&iPageIndex=${iPageIndex}&iPageSize=${iPageSize}`,
      {}
    ),
  addHuongDanSuDung: (params) =>
    API_AUTH.post("HDSD/InsertOrUpdateHDSD", params),
  xoaHuongDanSuDung: (Id) => {
    return API_AUTH.post(`HDSD/DeleteHDSD?Id=${Id}`, {});
  },
  chiTietHuongDanSuDung: (id) => {
    return API_AUTH.get(`HDSD/GetListHDSD_byId?id=${id}`, {});
  },
  chiTietPage: (Link) => {
    return API_AUTH.get(`HDSD/GetListHDSD_byLink?Link=${Link}`, {});
  },
};

export default HuongDanSuDungApi;
